import { render, staticRenderFns } from "./dr-checkbox.vue?vue&type=template&id=a4179f70"
import script from "./dr-checkbox.vue?vue&type=script&lang=js"
export * from "./dr-checkbox.vue?vue&type=script&lang=js"
import style0 from "./dr-checkbox.vue?vue&type=style&index=0&id=a4179f70&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../player/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports